import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const testimonials = [
  {
    name: "Aisha Khalid",
    feedback:
      "Working with 7DRE was a fantastic experience! They helped us find the perfect modern apartment in Abu Dhabi. Their team was attentive to our needs and budget, guiding us every step of the way. We couldn’t be happier with our new home!",
    avatar: "https://via.placeholder.com/64", // Replace with real image
    rating: 5,
  },
  {
    name: "Ahmed Khan",
    feedback:
      "The team at 7DRE made everything smooth. From paperwork to viewings, their service exceeded expectations.",
    avatar: "https://via.placeholder.com/64",
    rating: 5,
  },
];

const TestimonialsSection = () => {
  return (
    <div className="bg-white py-20 px-6">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
          What our customers say!
        </h2>
      </div>

      <Swiper
        modules={[Navigation]}
        navigation={true}
        loop
        slidesPerView={1}
        spaceBetween={50}
        className="max-w-4xl mx-auto"
      >
        {testimonials.map((item, idx) => (
          <SwiperSlide key={idx}>
            <div className="text-center">
              <p className="text-2xl leading-relaxed text-gray-800 mb-10">
                {item.feedback}
              </p>
              <div className="flex items-center justify-center gap-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div className="text-left">
                  <p className="font-bold text-lg text-gray-900">
                    {item.name}
                  </p>
                  <div className="text-yellow-500 text-xl">
                    {"★".repeat(item.rating)}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TestimonialsSection;
